//built-in libraries
//Third party libraries

import { InformationCircleIcon } from '@heroicons/react/24/solid';
//Assets and Miscellaneous
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { getBulkUserInvites } from '../../../../api/Terminal/UserAccount';
//services
import useParseCSV from '../../../../hooks/useParseCSV';
//Custom components
import Button from '../../../UI/Button';
import { HookForm } from '../../../UI/HookForm/Form';
import { HookFileInput } from '../../../UI/HookForm/Form/File';
import { HookFormProvider } from '../../../UI/HookForm/Provider';
import BulkUserInviteHistory from './components/BulkUserInviteHistory';
import BulkUserInviteSummary from './components/BulkUserInviteSummary';

//Component Begin
export default function MultipleUserInviteForm({ formModalHandler }: { formModalHandler: (modalName: 'inviteNewUser') => void }) {
  const [showHistory, setShowHistory] = useState(false);

  const { parseFile, uploadFile, showBulkUserInviteSummary, batchId, invalidRecords } = useParseCSV();

  //uplift: useQuery v5
  const fetchBulkUserInvites = useQuery({ queryKey: ['get-bulk-user-invites'], queryFn: () => getBulkUserInvites({}) });
  const recentBulkUserInvites = fetchBulkUserInvites?.data?.data[0];

  const onSubmit = (file: { selectedFile: File[] }) => {
    if (file?.selectedFile?.length) {
      parseFile(file.selectedFile);
    }
  };

  if (recentBulkUserInvites?.pending > 0 || recentBulkUserInvites?.processing > 0) {
    return (
      <>
        <p className='p-2 mt-2 bg-secondaryColor-lightest text-secondaryColor-normal flex gap-2'>
          <span>
            <InformationCircleIcon className='h-5 w-5' />
          </span>
          There is already a Bulk User Invite in progress
        </p>
        <BulkUserInviteSummary handleModal={formModalHandler} batchId={recentBulkUserInvites?.id} invalidRecords={invalidRecords} />
      </>
    );
  }

  if (showHistory) {
    return <BulkUserInviteHistory handleModal={formModalHandler} />;
  }

  return (
    <>
      {!showBulkUserInviteSummary && (
        <HookFormProvider>
          <HookForm onSubmit={onSubmit} className='pt-5'>
            <HookFileInput name='selectedFile' label='Upload File' id='selectedFile' required />
            <section className='flex gap-4 items-center mt-2 text-neutralColor-normal'>
              <a
                href='https://assets.seinterminal.com/files/STP_Bulk_User_Invite_Template.csv'
                target='_blank'
                rel='noreferrer noopener'
                className='hover:text-primaryColor-normal hover:underline cursor-pointer'
              >
                Download Sample
              </a>
              <span className='hover:text-primaryColor-normal hover:underline cursor-pointer' onClick={() => setShowHistory(true)}>
                History
              </span>
            </section>
            <div className='flex gap-2 items-center justify-end'>
              <Button
                label='Cancel'
                btnStyle='btn-neutral'
                type='button'
                disabled={uploadFile.isLoading}
                onClick={() => formModalHandler('inviteNewUser')}
              />
              <Button
                label={`${uploadFile.isLoading ? 'Sending Invite...' : 'Send Invite'}`}
                btnStyle='primary'
                type='submit'
                disabled={uploadFile.isLoading}
              />
            </div>
          </HookForm>
        </HookFormProvider>
      )}

      {showBulkUserInviteSummary && (
        <BulkUserInviteSummary handleModal={formModalHandler} batchId={batchId} invalidRecords={invalidRecords} />
      )}
    </>
  );
}
